import { LangEum } from '@/constant'

export const viewMore = {
  zh: '进入会场',
  'zh-TW': '進入會場',
  [LangEum['zh-MO']]: '進入會場',
  [LangEum['zh-TW2']]: '進入會場',
  en: `view more `,
  ja: '更に見る',
  [LangEum['zh-SG']]: '进入会场',
  [LangEum['zh-MY']]: '进入会场',
}
